module.exports = __webpack_public_path__ + "static/img/todo.047e470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/todo.png
// module id = 231
// module chunks = 1